import { Typography, TextField, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./gridControls.scss";

const DraggableContainedLabel = ({
  tab,
  value,
  model,
  dd,
  view,
  onUpdate,
  width,
}) => {
  const [data, setData] = useState(value);

  const handleFieldChange = () => (event) => {
    setData(event.target.value);
  };

  const updateText = async (event) => {
    if (event.key === "Enter" && data.trim() !== "") {
      if (tab === "DD-Name") {
        onUpdate(model, dd, data);
      }
      if (tab === "views") {
        onUpdate(view, data);
      }
    }
  };
  const onBlur = async () => {
    if (data.trim() !== "") {
      if (tab === "DD-Name") {
        onUpdate(model, dd, data);
      }
      if (tab === "views") {
        onUpdate(view, data);
      }
    }
  };
  return (
    <div
      className="contained-grid-container draggable-container"
      style={{ width: width }}
    >
      <Typography className="contained-grid-label">
        <DragIndicatorIcon
          style={{ marginBottom: "-10px" }}
          color="disabled"
          fontSize="small"
        />
        {tab !== undefined && (
          <Tooltip arrow title={data} placement="right-start">
            <TextField
              size="small"
              className="contained-grid-label"
              id="outlined-basic"
              placeholder=""
              label=""
              value={data}
              onChange={handleFieldChange()}
              onKeyDown={updateText}
              onBlur={onBlur}
            />
          </Tooltip>
        )}
        {tab === undefined && <span>{data}</span>}
      </Typography>
    </div>
  );
};

export default DraggableContainedLabel;
